module.exports = __webpack_public_path__ + "assets/img/java-icon.249fe040.svg";